import { ILabel, ILanguageRules } from "../Interfaces";
import { PluralOperands } from "../PluralOperands";

export class Rules implements ILanguageRules
{
    public getPlural(label: ILabel, count: number | string): string
    {
        const operands = new PluralOperands(count);
        if (operands.i == 1 && operands.v == 0)
        {
            return label.one;
        }
        else
        {
            return label.other;
        }
    }
}
